import { Component, ChangeDetectionStrategy, Input, inject, AfterViewInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { map } from 'rxjs';
import { ContentBlock } from 'src/app/content-blocks/models';
import { toSignal } from '@angular/core/rxjs-interop';
import { Header } from 'src/app/core/models/header.model';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import gsap from 'gsap';
import { SetNavTheme } from 'src/app/store';
gsap.registerPlugin(ScrollTrigger);

@Component({
  selector: 'app-content-block-container',
  templateUrl: './content-block-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockContainerComponent {
  private store = inject(Store);
  @Input() hasHeader?: boolean;
  @Input() hasDarkTheme?: boolean;
  @Input({ required: true }) blocks: ContentBlock[] = [];
  @Input() activeScrollTrigger: string[] | null = [];

  cookiePreferences$ = toSignal(
    this.store.select(getCookiePreferences).pipe(
      map(
        a =>
          a || {
            functional: false,
            analytical: false,
            marketing: false,
          }
      )
    )
  );

  trackByFn(index: number, block: ContentBlock) {
    return block.id;
  }

  hasBlocksInBlocks(block: ContentBlock) {
    return ['block-default', 'block-play-slide'].includes(block.blockType);
  }

  blockHasDarkTheme(block: ContentBlock) {
    const blocksAlwaysDark = ['block-carroussel'];
    const blocksAlwaysLight: string[] = [];
    //console.log('blockHasDarkTheme', this.hasDarkTheme, block);
    return (blocksAlwaysDark.includes(block.blockType) && !blocksAlwaysLight.includes(block.blockType)) || false;
  }

  onThemeChange(e: { theme: string; enter: boolean }) {
    if (!e.theme) {
      return;
    }
    if (e.enter) {
      this.store.dispatch(SetNavTheme({ theme: e.theme === 'dark' ? 'light' : 'dark' }));
    } else {
      this.store.dispatch(SetNavTheme({ theme: e.theme }));
    }
  }
}
